/**
 * @Author: luoob
 * @Date: 2021-10-28 21:23:03
 * @Last Modified by: luoob
 * @Last Modified time: 2021-10-28 21:23:12
 * @Instruduction: 麦媒云状态
 */

import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { WinpressService } from '@/services'
import store from '@/store'

export interface WinpressState {
    articleTypes: any[]                        // 文章分类
}

@Module({ dynamic: true, store, name: 'winpress' })
class Winpress extends VuexModule implements WinpressState {
    public articleTypes: any[] = []

    @Mutation
    SET_ARTICLE_TYPES(types: any[]) {
        this.articleTypes = types
    }

    @Action
    async getArticleTypes() {
        // 获取文章分类
        if (this.articleTypes.length) return
        const result = await WinpressService.getArticleTypes()
        if (result.status === 200) {
            this.SET_ARTICLE_TYPES(result.data)
        }
    }
}

export const WinpressModule = getModule(Winpress)
